var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room"},[(_vm.data.value.room.gds_blocks[0].blockName === 'acf/content-gallery')?_c('ContentGallery',{attrs:{"data":_vm.data.value.room.gds_blocks[0].attrs.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }